import { Avatar, Stack, Typography } from '@mui/material';
import React from 'react';

export const ClientNameAndAvatar = ({ title, subtitle, initials, width, colour, sx = {}, titleSx = {} }) => {
	
	return <Stack spacing={1} width='100%' sx={sx}>
		<Typography sx={{ ...(colour && { color: colour }), ...titleSx }} variant="avatar_title">
			{title}
		</Typography>
		{subtitle && <Typography variant="avatar_subtitle">
			{subtitle}
		</Typography>}
	</Stack>;
};